import { useState, useCallback } from 'react';
import { useRecipeCoupons } from './use-recipe-coupons';
import type { Recipe } from '../types/recipes';
import type { Coupon } from '@/Coupons/types/coupons';

interface UseRecipeCouponsUIResult {
  matchingCoupons: Coupon[];
  hasMatches: boolean;
  isLoading: boolean;
  couponsSheetOpen: boolean;
  setCouponsSheetOpen: (open: boolean) => void;
  handleBadgeClick: (e: React.MouseEvent) => void;
}

/**
 * Hook that combines coupon matching with UI state management.
 * Eliminates duplicate coupon UI logic across recipe components.
 */
export function useRecipeCouponsUI(recipe: Recipe | null): UseRecipeCouponsUIResult {
  const [couponsSheetOpen, setCouponsSheetOpen] = useState(false);
  const { matchingCoupons, hasMatches, isLoading } = useRecipeCoupons(recipe);

  const handleBadgeClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setCouponsSheetOpen(true);
  }, []);

  return {
    matchingCoupons,
    hasMatches,
    isLoading,
    couponsSheetOpen,
    setCouponsSheetOpen,
    handleBadgeClick,
  };
}
